import { Drawer, Modal, Select } from 'antd';
import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import React from 'react';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import styled from 'styled-components';
import KSpinner from 'common/component/KSpinner';
import { KButton } from 'common/component/KButton';
import DataTable from 'react-data-table-component';
import { ResultPublishForm } from './resultPublishForm';
import { useSubject } from '../hooks/useSubject';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useResult } from '../hooks/useResult';
import TableColumn from './result.table';
import _ from 'lodash';
import { useGrade } from 'features/routine/hooks/useGrade';
import { GradeModel } from 'data/grade/grade.model';
import { useExamRoutine } from 'features/examRoutine/hooks/useExamRoutine';
import { ResultGetModel } from 'data/result/result.model';

interface Props {}

export interface Student {
  student: string;
  studentId: any;
  percentage: number;
  status: number;
  totalSubjects: number;
  subjects: number;
}

interface MarkDetail {
  subject: string;
  obtainedMark: string;
}
const ResultView: React.FC<Props> = () => {
  const [visible, setVisible] = React.useState(false);
  const [selected, setSelected] = React.useState({
    selectedGrade: '',
    selectedSection: '',
    selectedExamYear: '',
    selectedExamType: '',
  });
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const [isGetResultIsClicked, setIsGetResultIsClicked] = React.useState<boolean>(false);
  const [reloadResult, setReloadResult] = React.useState(false);
  const { fetchResult, fetchResultByStudentId } = useResult();
  const results = useSelector((state: RootState) => state.result);
  const studentResult = useSelector((state: RootState) => state.studentResult);
  const examYear = useSelector((state: RootState) => state.examYear);
  const examType = useSelector((state: RootState) => state.examType);
  const grade = useSelector((state: RootState) => state.grade);
  const gradeSubjects = useSelector((state: RootState) => state.gradeSubjects);
  const [gradeData, setGradeData] = React.useState<GradeModel>({
    id: '',
    startTime: '',
    endTime: '',
    sections: [],
  });
  const [modalContent, setModalContent] = React.useState<Student>({
    student: '',
    studentId: '',
    percentage: 0,
    status: 0,
    totalSubjects: 0,
    subjects: 0,
  });
  const { fetchGrade, fetchGradeSubjects } = useGrade();
  const { fetchExamType, fetchExamYear } = useExamRoutine();
  let studentMarkDetails: MarkDetail[] = [];

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  let grouped_data = _(results.data)
    .groupBy((student) => student.student.__user__.full_name)
    .map((value, key) => ({
      Student: key,
      StudentId: _.get(_.find(value, 'studentId'), 'studentId'),
      data: value,
    }))
    .value();
  console.log('groupedData ', grouped_data);

  let totalSubjects: number = gradeSubjects.data.subjects.length;
  let studentTableData: Student[] = [];
  let status: number;

  grouped_data.map((each) => {
    let totalMark = 0;
    let totalObtainedMark = 0;
    let percentage;

    each.data.map((value) => {
      totalMark = totalMark + parseInt(value.subject.full_mark);
      totalObtainedMark = totalObtainedMark + parseInt(value.obtained_mark);
    });
    percentage = (totalObtainedMark / totalMark) * 100;
    console.log('marks', percentage, totalObtainedMark, totalMark);

    if (totalSubjects === each.data.length) {
      status = 100;
    }
    if (totalSubjects > each.data.length && totalSubjects / 2 < each.data.length) {
      status = 75;
    }
    if (totalSubjects > each.data.length && totalSubjects / 2 === each.data.length) {
      status = 50;
    }
    if (totalSubjects / 2 > each.data.length && each.data.length !== 0) {
      status = 25;
    }
    if (each.data.length === 0) {
      status = 0;
    }

    studentTableData.push({
      student: each.Student,
      studentId: each.StudentId,
      percentage: percentage,
      status: status,
      totalSubjects: totalSubjects,
      subjects: each.data.length,
    });
    console.log('StudentTableData ', studentTableData);
  });
  const handleGetResult = (): void => {
    fetchResult(
      selected.selectedGrade,
      selected.selectedSection,
      selected.selectedExamYear,
      selected.selectedExamType,
    );
    fetchGradeSubjects(selected.selectedGrade);
    setIsGetResultIsClicked(true);
  };

  const handleModal = (row: Student) => {
    fetchResultByStudentId(row.studentId);
    setModalContent(row);
    setIsModalVisible(true);
  };

  gradeSubjects.data.subjects.map((subjects) => {
    studentResult.data.map((student) => {
      if (student.subjectId === subjects.id) {
        studentMarkDetails.push({
          subject: subjects.title,
          obtainedMark: student.obtained_mark,
        });
      }
    });
    const result = studentResult.data.find((student) => student.subjectId === subjects.id);
    if (result === undefined) {
      studentMarkDetails.push({
        subject: subjects.title,
        obtainedMark: '-',
      });
    }
  });

  React.useEffect(() => {
    fetchGrade();
    fetchExamType();
    fetchExamYear();
  }, []);

  React.useEffect(() => {
    if (reloadResult === true && isGetResultIsClicked) {
      fetchResult(
        selected.selectedGrade,
        selected.selectedSection,
        selected.selectedExamYear,
        selected.selectedExamType,
      );
      fetchGradeSubjects(selected.selectedGrade);

      setReloadResult(false);
    }
  }, [reloadResult]);

  return (
    <ResultWrapper>
      <KPageHeader
        title="Result"
        rightButtonTitle="Publish Result"
        onRightButtonClick={showDrawer}
      />
      <Drawer
        title={<h2>Publish Result</h2>}
        width={720}
        visible={visible}
        closable={false}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
      >
        {
          <ResultPublishForm
            onVisibleChange={setVisible}
            onSetReloadResult={setReloadResult}
            examType={examType.data}
            examYear={examYear.data}
            grade={grade.data}
          />
        }
      </Drawer>
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing all the results of students that are currently in this system"
      />

      <section className="section-wrapper">
        <section className="page-tabs">
          <Select
            defaultValue="Select Grade"
            className="select-field"
            onSelect={(value) => {
              setSelected((prevSelected) => ({ ...prevSelected, selectedGrade: value }));
              grade.data.map((item) => {
                if (item.id === value) {
                  setGradeData(item);
                }
              });
            }}
          >
            {grade.data.map((item) => (
              <Select.Option key={`atten-class${item.id}`} value={item.id}>
                {item.id}
              </Select.Option>
            ))}
          </Select>
        </section>
        <section className="page-tabs">
          <Select
            defaultValue="Select Section"
            className="select-field"
            onSelect={(val) => {
              setSelected((prevSelected) => ({ ...prevSelected, selectedSection: val }));
            }}
          >
            {gradeData.sections.map((section) => (
              <Select.Option key={`atten-class${section.id}`} value={section.id}>
                {section.id}
              </Select.Option>
            ))}
          </Select>
        </section>
        <section className="page-tabs">
          <Select
            className="select-field"
            defaultValue="Select Exam Year"
            style={{ width: '180px', marginRight: '10px' }}
            onSelect={(value) => {
              setSelected((prevSelected) => ({ ...prevSelected, selectedExamYear: value }));
            }}
          >
            {examYear.data.map((item) => (
              <Select.Option value={item.id}> {item.id}</Select.Option>
            ))}
          </Select>
        </section>
        <section className="page-tabs">
          <Select
            className="select-field"
            defaultValue="Select Exam Type"
            style={{ width: '180px', marginRight: '10px' }}
            onSelect={(value) => {
              setSelected((prevSelected) => ({ ...prevSelected, selectedExamType: value }));
            }}
          >
            {examType.data.map((item) => (
              <Select.Option value={item.id}> {item.id}</Select.Option>
            ))}
          </Select>
        </section>
        <KButton onClick={handleGetResult}>Get Result</KButton>
      </section>

      {isGetResultIsClicked && (
        <section className="page-table">
          {results.status === 'loading' && <KSpinner />}
          {results.status === 'data' && (
            <DataTable
              customStyles={tableCustomStyles}
              className="data-table"
              noHeader
              highlightOnHover
              responsive={true}
              data={studentTableData}
              columns={TableColumn()}
              onRowClicked={(row) => handleModal(row)}
            />
          )}
          <Modal
            title={<h3 style={{ fontWeight: 700 }}>Student Marks Detail</h3>}
            width={1000}
            visible={isModalVisible}
            onOk={() => setIsModalVisible(false)}
            onCancel={() => setIsModalVisible(false)}
          >
            <h4 style={{ fontWeight: 700 }}>Student Name: {modalContent.student}</h4>
            <h4 style={{ fontWeight: 700 }}>Percentage: {modalContent.percentage}%</h4>

            <DataTable
              className="data-table"
              customStyles={tableCustomStyles}
              data={studentMarkDetails}
              columns={[
                {
                  name: 'Subject',
                  selector: 'subject',

                  cell: (row: MarkDetail) => (
                    <div>
                      <div>{row.subject}</div>
                    </div>
                  ),
                },
                {
                  name: 'Mark',
                  selector: 'obtainedMark',

                  cell: (row: MarkDetail) => (
                    <div>
                      <div>{row.obtainedMark}</div>
                    </div>
                  ),
                },
              ]}
            />
          </Modal>
        </section>
      )}
    </ResultWrapper>
  );
};

export const ResultWrapper = styled.div`
  padding-right: 20px;
  .page-tabs {
    margin: 16px 0;
    display: flex;
    justify-content: space-evenly;
    .select-field {
      min-width: 200px;
    }
  }

  .section-wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
`;

export default ResultView;
